export default __webpack_public_path__ + "static/media/graz3_dark.25cd6db4.png";